<template>
  <div class="network-metrics" data-cy="network-metrics" v-if="showPanel">
    <div class="title">Network Metrics</div>
    <div class="row"><span>Status</span><strong>{{ connectionStatus }}</strong></div>
    <div class="row"><span>Role</span><strong>{{ roleLabel }}</strong></div>
    <div class="row"><span>Connect</span><strong>{{ connectLabel }}</strong></div>
    <div class="row"><span>RTT</span><strong>{{ rttLabel }}</strong></div>
    <div class="row"><span>Msgs</span><strong>{{ messageLabel }}</strong></div>
    <div class="row"><span>Rate</span><strong>{{ rateLabel }}</strong></div>
    <div class="row"><span>Wires</span><strong>{{ metrics.bugs.wires }}</strong></div>
    <div class="row"><span>Tracker</span><strong>{{ trackerLabel }}</strong></div>
    <div class="row"><span>Announce</span><strong>{{ announceLabel }}</strong></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

function formatAgo(timestamp) {
  if (!timestamp) {
    return '-'
  }
  const ageMs = Math.max(0, Date.now() - timestamp)
  const ageSec = Math.round(ageMs / 1000)
  return `${ageSec}s ago`
}

export default {
  computed: {
    ...mapGetters('NetworkInterface', [
      'metrics',
      'connectionStatus',
      'networkMetricsVisible',
      'session',
    ]),
    showPanel() {
      return this.networkMetricsVisible && this.session && (this.session.isController() || this.session.isScreen())
    },
    roleLabel() {
      return this.metrics.role || '-'
    },
    connectLabel() {
      if (this.metrics.connectDurationMs === null) {
        return '-'
      }
      return `${this.metrics.connectDurationMs} ms`
    },
    rttLabel() {
      const last = this.metrics.latency.lastRttMs
      const avg = this.metrics.latency.avgRttMs
      const p95 = this.metrics.latency.p95RttMs
      if (last === null && avg === null && p95 === null) {
        return '-'
      }
      return `${last !== null ? last : '-'} / ${avg !== null ? avg : '-'} / ${p95 !== null ? p95 : '-'} ms`
    },
    messageLabel() {
      return `${this.metrics.messages.inCount} in / ${this.metrics.messages.outCount} out`
    },
    rateLabel() {
      return `${this.metrics.messages.inRateBytesPerSec} B/s in / ${this.metrics.messages.outRateBytesPerSec} B/s out`
    },
    trackerLabel() {
      return formatAgo(this.metrics.bugs.trackerAt)
    },
    announceLabel() {
      return formatAgo(this.metrics.bugs.announceAt)
    },
  },
}
</script>

<style lang="scss" scoped>
@import './../../../colors.scss';

.network-metrics {
  position: fixed;
  right: 10px;
  top: 56px;
  z-index: 10000;
  min-width: 310px;
  border: 1px solid $main;
  background: rgba(var(--theme-bg-rgb), 0.5);
  padding: 8px 10px;
  font-family: var(--theme-control-font);
  font-size: 14px;
  pointer-events: none;

  .title {
    font-size: 16px;
    margin-bottom: 6px;
  }

  .row {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin: 2px 0;
  }
}
</style>
